import BigNumber from 'bignumber.js';

/**
 * Convert a string value to wei
 * @param value The value
 */
export function parseEther(value: BigNumber): BigNumber {
  return new BigNumber(value)
}
